/* global Promise */
( function() {
	document.addEventListener( 'DOMContentLoaded', init );

	// fired by facilities-ajax.js
	document.body.addEventListener( 'facility-result-rendered', init );

	function init() {
		const adCarousels = document.querySelectorAll( '.ad-carousel' );
		if( !adCarousels ) { return; }

		Array.from( adCarousels ).forEach( adCarouselEle => {
			const filterEles = adCarouselEle.querySelectorAll( '.ad-carousel__filters a' );
			if( !filterEles ) { return; }

			Array.from( filterEles ).forEach( filterEle => filterEle.addEventListener( 'click', clickFilter ) );
		} );
	}

	function clickFilter( e ) {
		e.preventDefault();
		const carouselEle = e.target.closest( '.ad-carousel' );

		const activeFilter = 'ad-carousel__filters--active';
		carouselEle.querySelector( '.' + activeFilter ).classList.remove( activeFilter );
		e.target.classList.add( activeFilter );

		const tabPanel = carouselEle.querySelector( e.target.getAttribute( 'href' ) ); // id selector
		const activeTab = 'ad-carousel--active';
		carouselEle.querySelector( '.' + activeTab ).classList.remove( activeTab );
		tabPanel.classList.add( activeTab );

		if( tabPanel.querySelector( '.scroll-carousel__container li' ) || tabPanel.getAttribute( 'aria-busy' ) == 'true' ) { return; }

		tabPanel.setAttribute( 'aria-busy', true );
		updateError( tabPanel, true );

		const endpoint = e.target.dataset.endpoint;
		
		fetch( endpoint, { method: 'get', headers: { 'Content-Type': 'text/html; charset=utf-8' } } )
			.then( ( response, rejectResponse ) => {
				if( response.ok ) {
					return response.text();
				}
				return Promise.reject( rejectResponse );
			} )
			.then( responseHtml => {
				const doc = ( new DOMParser() ).parseFromString( responseHtml, 'text/html' );
				const newContents = doc.querySelector( '.scroll-carousel' ).children;
				const container = tabPanel.querySelector( '.scroll-carousel' );

				if( !newContents.length ) {
					updateError( tabPanel );
					return;
				}

				Array.from( newContents ).forEach( ele => {
					container.appendChild( ele );
				} );
				container.dispatchEvent( new Event( 'scroll-carousel-rendered' ) );
			} )
			.catch( ( error ) => {
				updateError( tabPanel );
				// eslint-disable-next-line no-console
				console.error( 'there was an error', error );
			} )
			.finally( () => {
				tabPanel.setAttribute( 'aria-busy', false );
			} );
	}

	function updateError( tabPanel, hide ) {
		const err = tabPanel.querySelector( '.ad-carousel__error' );
		const cl = 'ad-carousel__error--show';
		if( hide === true ) {
			err.classList.remove( cl );
		} else {
			err.classList.add( cl );
		}
	}
} )();
